import { Transaction, TransactionType, TransactionWarehouse } from "../types";

const signersConverter = (
  warehouse?: TransactionWarehouse,
  apiBaseUrl?: string
) =>
  warehouse?.signers.map((signer) => ({
    ...signer,
    signatureImageUrl: signer.signatureImageUrl
      ? `${apiBaseUrl}${signer.signatureImageUrl}`
      : signer.signatureImageUrl,
  })) || [];

export const transactionPhotosConverter = (
  t: Transaction,
  apiBaseUrl?: string
) => {
  if (t.transactionType === TransactionType.Retreading) return t;

  const materialPhotos = t.materialPhotos?.map(
    (path: string) => `${apiBaseUrl}${path}`
  );
  const paperFormImages = t.paperFormImages?.map(
    (path: string) => `${apiBaseUrl}${path}`
  );
  const scaleTickets = t.scaleTickets?.map((scaleTicket) => ({
    ...scaleTicket,
    ticket: scaleTicket.ticket ? `${apiBaseUrl}${scaleTicket.ticket}` : null,
  }));
  const sourceWarehouseSigners = signersConverter(
    t.sourceWarehouse,
    apiBaseUrl
  );
  const targetWarehouseSigners = signersConverter(
    t.targetWarehouse,
    apiBaseUrl
  );

  return {
    ...t,
    materialPhotos,
    paperFormImages,
    scaleTickets,
    sourceWarehouse: t.sourceWarehouse
      ? {
          ...t.sourceWarehouse,
          signers: sourceWarehouseSigners,
        }
      : undefined,
    targetWarehouse: t.targetWarehouse
      ? {
          ...t.targetWarehouse,
          signers: targetWarehouseSigners,
        }
      : undefined,
  };
};

export default transactionPhotosConverter;
